import React from 'react';
import styled from 'styled-components';
import { Grid, Typography } from '@material-ui/core';
import { textBold, colors } from 'styles';
import { Content } from 'components/basics';
import { breakpoint } from 'utils/mediaQueries';

const ContentBlock = styled(Grid)`
  ${Content};
  text-align: center;
  padding-bottom: 2rem;
`;
// TODO colors with nthchild or classes ?
const TitleEmotions = styled(Typography)`
  padding: 1rem;
  margin-bottom: 0;
  ${textBold};
  font-size: ${props => `${props.theme.typography.h5.fontSize}px`};
  ${breakpoint.down('md')`
    font-size: ${props => `${props.theme.typography.h6.fontSize}px`}`}
  ${breakpoint.down('md')`
    font-size: ${props => `${props.theme.typography.body1.fontSize}px`}`}
  ${breakpoint.only('xxs')`
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};
  `};
  .red {
    color: ${colors.red};
  }
  .orange {
    color: ${colors.orange};
  }
  .blue {
    color: ${colors.lightBlue};
  }
  .darkBlue {
    color: ${colors.darkBlue};
  }
`;

const TitleEmotionsBlock = ({ data }) => {
  return (
    <ContentBlock
      container
      justify="center"
      item
      xs={'auto'}
      sm={10}
      md={10}
      lg={10}
    >
      <TitleEmotions
        variant="h2"
        dangerouslySetInnerHTML={{ __html: data.rawMarkdownBody }}
      />
    </ContentBlock>
  );
};

export default TitleEmotionsBlock;
